import React, { FC, useEffect } from 'react'
import { useHistory } from 'react-router'
import { Lobby } from 'src/components/LobbyTour'
import { CurrentUserType } from 'src/ducks/auth'
import routes from 'src/routes'
import config from '../../config'
import Amplitude from '../../utils/amplitudeHelper'
import { StyledLobby } from './styled'

export const LobbyPage: FC<{ currentUser: CurrentUserType }> = ({ currentUser }) => {
  const history = useHistory()

  const routePath = {
    Auditorium: routes.auditorium1,
    Gallery: routes.onDemand,
  }

  useEffect(() => {
    document.title = `${config.eventName} | Lobby`
  }, [])

  useEffect(() => {
    Amplitude.visit('Lobby')
    Amplitude.visitTemp(`Lobby`)
  }, [currentUser.id])

  useEffect(() => {
    function callback(e) {
      if (e) {
        history.push(routePath[e.data])
      }
    }
    window.addEventListener('message', callback)

    return () => {
      window.removeEventListener('message', callback)
    }
  }, [])

  return (
    <>
      <StyledLobby>
        <Lobby currentUser={currentUser} />
      </StyledLobby>
    </>
  )
}
